/**
 * Converts a number or an array of numbers to a pixel string. Useful for CSS
 * props like padding, margin, etc. that accept strings with multiple size
 * values. For example:
 *
 * ```
 * const padding = toPixelString([4, 12]);  // Returns `4px 12px`
 * ```
 */ export function toPixelString(num) {
    const array = Array.isArray(num) ? num : [
        num
    ];
    return array.map((val)=>`${val}px`).join(' ');
}

//# sourceMappingURL=to-pixel-string.js.map